import { inter } from './fonts';

/**
 * Global styles - twin.macro BaseStyles removed during migration.
 *
 * `--font-inter` carries the family name next/font generated for Inter (it is hashed, not
 * 'Inter'). Tailwind's `font-sans` reads it (see tailwind.config.js), and so do the few inline
 * styles that name the font.
 */
const GlobalStyles = () => (
  <style jsx global>{`
    :root {
      --font-inter: ${inter.style.fontFamily};
    }
  `}</style>
);

export default GlobalStyles;
